import React, {Component} from 'react';
import __ from 'lodash';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
// import ModalAddUpd from './ModalAddUpd';

import Loader from '../../../../Loader';
//import DropdownKelas from '../../masterDropDown/DropdownKelas'
import DropdownMapel from '../../masterDropDown/DropdownMapel'
import {Modal} from 'react-bootstrap';
import LoaderModal from '../../../../modal/LoaderModal';

class ListGuruMapel extends Component{
    constructor(props){
        super(props);
        this.state={
            isFetching: false,
            showModal:false,
            namaGuru : null,
            idGuru:null,
            idDetailGuruMapel:null,
            idKelas:null,
            idMapel:null,
            namaMapel: null,
            action:null,
            mapel:[],
            kelas:[],
            dataGuruMapel: [],
            dataKepalaGuruMapel: [],
            errorMessage: ''
        }
    }

    componentDidMount() {
        //console.log(this.props)
        this.setState({
            //dataGuruMapel: this.props.dataGuruMapel,
            //dataKepalaGuruMapel: this.props.dataKepalaGuruMapel
        })
    }

    getKelas = async(idGuru) => {
        this.setState({isFetching: true})
        const res = await accountManagement.get(CONFIG.GET_KELAS_BY_GURU + idGuru).catch(function(error){
        })
        if(res){
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: res.data.data,
                    errorMessage: '',
                    showModal: true,
                    isFetching: false
                })
            } else {
                this.setState({
                    kelas: [],
                    errorMessage:res.data.errorSchema.errorMessage,
                    showModal: true,
                    isFetching: false
                })                
            }
        } 
    }

    renderList(){
        return(
            <div id="accordion"> 
                {this.setParentList()}      
            </div> 
        )
        
    }

    changeSeletedIdGuru(id, nama){      
        this.getKelas(id);
        this.setState({
            idGuru:id,
            idDetailGuruMapel:null,
            idKelas:null,
            idMapel:null,
            action:"Tambah Mapel ",
            namaGuru : nama,  
        })
    }
    changeSeletedUpDel(params){
        // params=> idGuru, idDetailMapel, idKelas idMapel
        // this.setState({actionUpDel:params})
        let data = params.split("-");
        this.getKelas(data[1]);
        if(data[0] != "Hapus "){
            if(this.state.idKelas != data[3]){this.fetchMapel(data[3]);}
        }
        this.setState({
            idGuru:data[1],
            idDetailGuruMapel:data[2],
            idKelas:data[3],
            idMapel:data[4],
            namaGuru:data[5],
            namaMapel: data[6],
            action:data[0],
            kelas: this.state.kelas,
            showModal: true
        })

    }

    setParentList(){
        if(!__.isEmpty(this.props.dataKepalaGuruMapel)){
                return this.props.dataKepalaGuruMapel.map((val,i) => {
                    return (
                        <div className="card" style={{marginBottom: '5px'}} >
                            <div className="card-header">                    
                                <div className="row">
                                    <div className="col-sm-5 col-xs-5">
                                        <div className="row">
                                            <div className="col-sm-9 col-xs-9">
                                                <a className="card-link" data-toggle="collapse" href={'#child'+val.ID_GURU}>
                                                {val.NAMA_GURU} <i className="fa fa-angle-down" aria-hidden="true" ></i>
                                                </a>
                                            </div>   
                                        </div>
                                    </div>
                                    <div className="col-sm-7 col-xs-7">
                                        <div className="pull-right">
                                            
                                            <button className="btn btn-outline-primary" data-toggle="modal" 
                                                data-target="#ModalGuruMapel" data-backdrop="static" data-keyboard="false" 
                                                title="Tambah Mapel" onClick={this.changeSeletedIdGuru.bind(this, val.ID_GURU, val.NAMA_GURU)}>
                                                <li className="fa fa-plus"> Mapel</li>
                                            </button> 
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            {this.renderTableChild(val.ID_GURU, i)}                   
                        </div>   
                    )
                })
        }
    }

    renderTableChild(id, i){
        return(
            <div id={'child'+id} class="panel-collapse collapse" data-parent="#accordion">
                <table class="table table">
                    <thead>
                        <tr>
                            <th key={i+1}>Nama Mapel</th>
                            <th key={i+2}>Kelas</th>
                            <th key={i+3}>#</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderChild(id)}
                    </tbody>
                </table>
            </div>
        )
    }

    renderChild(id){
        if(!__.isEmpty(this.props.dataGuruMapel)){
            return this.props.dataGuruMapel.map((valChild,j) => {
                if(id===valChild.idGuru && valChild.idMapel!=null){
                    return (
                        <tr>
                            <td key={j+1}>{valChild.namaMapel}</td>
                            <td key={j+2}>{valChild.namaKelas}</td>
                            <td key={j+3}>
                                <button className="btn btn-warning" title="Edit" data-toggle="modal" 
                                        data-target="#ModalGuruMapel" data-backdrop="static" data-keyboard="false"
                                        onClick={this.changeSeletedUpDel.bind(this, 'Edit Mapel -'+id+'-'+valChild.idDetailGuruMapel+'-'+valChild.idKelas+'-'+valChild.idMapel+'-'+valChild.namaGuru)}>
                                    <li className="fa fa-pencil"></li>
                                </button>
                                &nbsp;
                                <button className="btn btn-danger" title="Hapus"  data-toggle="modal" 
                                        data-target="#ModalGuruMapel" data-backdrop="static" data-keyboard="false"
                                        onClick={this.changeSeletedUpDel.bind(this, 'Hapus -'+id+'-'+valChild.idDetailGuruMapel+'-'+valChild.idKelas+'-'+valChild.idMapel+'-'+valChild.namaGuru
                                            +'-'+valChild.namaMapel)}>
                                    <li className="fa fa-trash"></li>
                                </button>
                            </td>
                        </tr>
                    )
                }                
            })
        }
    }

    render(){        
        return(
            <div>
                <LoaderModal isFetching={this.state.isFetching} />
                {this.renderList()}
                {this.showModal()}
            </div>
        )
    }

    //==================================== || MANAGEMENT MODAL ADD/EDIT/DELETE || =====================================//
    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }

    fetchMapel = async (idKelas) => {
        
        this.setState({isSearch: true});

        if(this.state.action !="Hapus "){
            const resMapel = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_FETCH_MAPEL_BY_ID_KELAS + idKelas).catch(function(error){
            })
            if(resMapel){
                if(resMapel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        mapel: resMapel.data.data
                    })
                }
            } 
        
            console.groupCollapsed('________ FETCH MAPEL')
            console.log(resMapel);
            console.groupEnd();
            this.setState({isSearch: false});
        }
    }    

    handleModalMgtGuru = async (e)=>{
         this.setState({isFetching: true})
        e.preventDefault(); 
        // const {dataGuruMapel} = this.state.dataGuruMapel;

        // console.log('props,' ,this.props)
        // console.log('state,' ,this.state)
        // this.setState({ dataGuruMapel: dataGuruMapel.filter(item => item.idDetailGuruMapel !== this.state.idDetailGuruMapel)})
        

        if(this.state.action !="Hapus "){
            const resExcuteGuruMpl = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_ADD_UP_GURUMAPEL,{
                ...this.state
            }).catch(function(error){
            })

            if(resExcuteGuruMpl) {
                if(resExcuteGuruMpl.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){        
                    this.setState({ showModal: false})
                    window.location.reload()
                }
                
                this.setState({isFetching: false})                
            }
            
        }else{
            const resExcuteGuruMpl = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_DELETE_GURUMAPEL + this.state.idDetailGuruMapel).catch(function(error){
            })
            if(resExcuteGuruMpl) {
                if(resExcuteGuruMpl.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){        
                    this.setState({ showModal: false})
                    window.location.reload()
                }
                this.setState({isFetching: false})
            }
        } 
    }

    handleOnChangeDd = async (e) =>{
        this.setState({[e.target.id]: e.target.value})
        if(e.target.id == "idKelas"){
            if(e.target.value != this.state.idKelas){
                this.fetchMapel(e.target.value)
            }
        }
        
    }    

    showModal(){ 
        const {showModal,kelas, errorMessage} = this.state;   
        const handleClose = () => this.setState({showModal: false});
        
        if(errorMessage != '') {
            return (
                <Modal show={showModal} size="lg" onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.action} .. {this.state.namaGuru}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="text-center">
                            <p>{errorMessage}</p>
                            <p>Guru Belum memiliki kelas....</p>
                        </div>                        
                    </Modal.Body>
                </Modal>
            )
        }
        return(
            <Modal show={showModal} size="lg" onHide={handleClose}>
                {this.fetchMapel}
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.action} .. {this.state.namaGuru}</Modal.Title>
                </Modal.Header> 

                <form id="form-tambah" onSubmit={this.handleModalMgtGuru}>
                    <div className="modal-body">
                        {this.loading()}
                        <input type="hidden" value={this.state.idGuru} id="idGuru"/>
                        {this.state.action!="Hapus " ?
                        <div className="row"> 
                            <div className="col-md-6">
                                <label>Pilih Kelas</label>
                                <select className="form-control" id="idKelas" value={this.state.idKelas != null ? this.state.idKelas : ""}
                                    onChange={this.handleOnChangeDd} required>
                                    <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                    {kelas.map(k =>
                                        <option value={k.ID_KELAS}>{k.NAMA_KELAS}</option>    
                                    )}
                                </select>                                       
                            </div>
                            
                            <div className="col-md-6">
                                <label>Mata Pelajaran</label>
                                <select className="form-control" id="idMapel" value={this.state.idMapel != null ? this.state.idMapel : ""}
                                    onChange={this.handleOnChangeDd} disabled={this.state.isSearch ? "disabled" : ""} required >
                                    <option value="">~~ Pilih Mapel ~~</option>
                                    {this.state.mapel != null && <DropdownMapel  mapel={this.state.mapel}/>}
                                </select>
                            </div>
                        </div>
                        :
                        <div>
                            <div className="col-md-12">
                                <label>Hapus Mata Pelajaran {this.state.namaMapel} dari Guru ?</label>                                       
                            </div>
                        </div>
                        }
                    </div>

                    <div className="modal-footer">
                        
                        
                        <button type="submit" className="btn btn-primary" disabled={this.state.isSearch ? "disabled" : ""}>Simpan</button>
                    </div>
                </form>   
            </Modal> 
        );
                
    }


    componentDidUpdate(){
        console.groupCollapsed('________DidUpdate UPDATE MODAL')
        console.log(this.state);
        console.groupEnd();   
    }

}
export default ListGuruMapel;